module.exports = __webpack_public_path__ + "img/huodong.5fb3b6ad.png";